import React, {useEffect, useState} from 'react';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import "swiper/css/navigation"
// import CSS
import "../../assets/styles/CoachesCss/styles.css"
import "../../assets/styles/CoachesCss/z.css"
import "../../assets/styles/CoachesCss/z2.css"
import "../../assets/styles/CoachesCss/z3.css"
import "../../assets/styles/CoachesCss/z4.css"
import "../../assets/styles/CoachesCss/coachslider.css"

import {Swiper, SwiperSlide} from "swiper/react";
import baseApi from "../../apis/baseApi";
import {Navigation} from "swiper/modules";


interface Coach {
    full_name: string;
    img: string | null;
}


const CoachesSlider: React.FC = () => {
    const [coaches, setCoaches] = useState<Coach[]>()

    useEffect(() => {
        const params = new URLSearchParams(window.location.search)
        const studio = params.get('studio')
        baseApi.get<Coach[]>(`/coaches/public/?studio=${studio}`).then(resp => {
            setCoaches(resp.data)
        })
    }, []);

    if (!coaches) return <div/>
    return (
        <div style={{overflow: "hidden"}} >
            <div className='game-section'>
                <div className="ro mobile-margin-left" style={{backgroundColor: "transparent"}}>
                    <Swiper
                        spaceBetween={20}
                        slidesPerView={'auto'}
                        loop={true}
                        grabCursor={true}
                        navigation={true}
                        modules={[Navigation]}
                        className="mySwiper"
                    >
                        {coaches?.map((item, index) => (
                            <SwiperSlide key={index} className='w-coach overlay '>
                                <div className="item" style={{backgroundImage: `url(${item.img})`}}>
                                    <div style={{color: "#ffffff"}} className="item-desc text-left">
                                        <h6 style={{textTransform: "uppercase", color: "transparent"}}>Nombre</h6>
                                        <h3>{item.full_name}</h3>
                                    </div>
                                </div>
                                <div className='overlay-layer'
                                     style={{
                                         // background: config?.texts.coachGradient,
                                         // color: config?.colors.white
                                     }}>
                                    <div className='px-4'>
                                        {/*<div>*/}
                                        {/*    <div className='coach-titles'>{item.coachDetailTitle1}</div>*/}
                                        {/*    <div className='coach-descriptions'>{item.coachDetailText1}</div>*/}
                                        {/*</div>*/}

                                        {/*<div className='mt-3'>*/}
                                        {/*    <div className='coach-titles'>{item.coachDetailTitle2}</div>*/}
                                        {/*    <div className='coach-descriptions'>{item.coachDetailText2}</div>*/}
                                        {/*</div>*/}

                                        {/*<div className='mt-3'>*/}
                                        {/*    <div className='coach-titles'>{item.coachDetailTitle3}</div>*/}
                                        {/*    <div className='coach-descriptions'>{item.coachDetailText3}</div>*/}
                                        {/*</div>*/}

                                        {/*<div className='mt-2'>*/}
                                        {/*    /!*<a href={item.coachinstagram}><FontAwesomeIcon icon={faInstagram} /></a>*!/*/}
                                        {/*</div>*/}

                                    </div>
                                </div>
                            </SwiperSlide>

                        ))}
                    </Swiper>
                </div>
            </div>
        </div>
    );
};

export default CoachesSlider;